// 補藥 component

<template lang="pug">
  div
    div.upper-subpanel.row
      progressBar
      div.upper-subpanel--without-progressbar
        div.row(
          style="width: 100%; height: 100%; margin: 0" 
          v-if="stage === 'selectDrug' || stage === 'selectLowStock' || stage === 'refill' || stage === 'DrugStorageInOneMed'")
          div.col-6
            ScanBarcode(v-on:setBarcode="getBarcode" style="flex-direction: column")
              div.with-child-centered
                h2(v-if="stage === 'selectDrug'") [ 手動藥倉補藥 ]
                h2(v-if="stage === 'selectLowStock'") [ 存量過低藥物 ]
                h2(v-if="stage === 'refill'") [ 藥倉補藥規劃 ]
                div(v-if="stage === 'DrugStorageInOneMed'")
                  h4.text-center 請選擇待補藥盒或補藥至新藥盒
                div(v-else)
                  h4.text-center 請掃描藥盒(身)條碼進行補藥
                  h4.text-center 或於右方選擇待補藥物種類
               
          div.col-6
            drugList(
              v-if="stage === 'selectDrug'" 
              :viewMode="'medList'" 
              v-on:setDrugStorageWithSameMed="getDrugStorageWithSameMed"
              :medSelectMode="'selectDrugStorage'"
              :drugItemHeadWidth="'500px'"
              )
            drugList(
              v-if="stage === 'selectLowStock'" 
              :mode="'lowStock'" 
              :viewMode="'medList'"
              v-on:setDrugStorageWithSameMed="getDrugStorageWithSameMed"
              :medSelectMode="'selectDrugStorage'"
              )
            drugList(
              v-if="stage === 'refill'" 
              :mode="'refill'" 
              :viewMode="'medList'"
              v-on:setDrugStorageWithSameMed="getDrugStorageWithSameMed"
              :medSelectMode="'selectDrugStorage'"
              )
            drugList(
              v-if="stage === 'DrugStorageInOneMed'"
              :showRefillToNewDrugStorage="true"
              v-on:setNewDeviceForRefill="getNewDeviceForRefill"
              )
        MultiFlow(v-if="stage === 'setFlowData'" 
          :startType="startType"
          :multiProgress="multiProgress"
          :confirmProgress="confirmProgress"
          v-on:setAllConfirmData="getAllConfirmData")
        Loader(v-if="stage === 'finish'")
    BottomButtons
      action-button(title="回主畫面" slot="button-1" @click.native="cancel")
      action-button(title="手動補藥" slot="button-3" @click.native="changeStage('selectDrug')" v-show="currentStep === 'selectDrug'")
      action-button(title="存量過低" slot="button-4" @click.native="changeStage('selectLowStock')" v-show="currentStep === 'selectDrug'")
      action-button(title="補藥規劃" slot="button-5" @click.native="changeStage('refill')" v-show="currentStep === 'selectDrug'")
      action-button(title="選擇全部" slot="button-7" @click.native="selectAll" v-if="currentStep === 'selectDrug'")
      action-button(title="取消選擇" slot="button-7" @click.native="deselectAll" v-if="currentStep === 'selectDrug'")
      action-button(title="開始補充" slot="button-9" @click.native="startFlow" v-if="stage !== 'setFlowData'")
    RefillSelection(
      v-if="showRefillSelection" 
      :drugStorageIds="drugStorageIdsForSelected" 
      v-on:selectionDone="selectionDone"
      v-on:cancelSelection="cancelSelection")
</template>


<script>
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import drugList from './flowComp/DrugInDeviceList';
import progressBar from './flowComp/ProgressBar';
import MultiFlow from './RefillDrugFlow/MultiFlow';
import Loader from './common/Loader';
import BottomButtons from './common/BottomButtons';
import ScanBarcode from './flowComp/ScanBarcode';
import RefillSelection from './flowComp/RefillSelection';
import AppBase from './ComponentBase/AppBase';


export default {
  name: 'RefillDrug',
  extends: AppBase,
  components: {
    drugList,
    progressBar,
    MultiFlow,
    Loader,
    BottomButtons,
    ScanBarcode,
    RefillSelection,
  },
  data() {
    return {
      enterType: '',
      showRefillSelection: false,
      drugStorageIdsForSelected: [],
      startType: 'refill',
      refillToNewDevice: false,
    };
  },
  computed: {
  },
  created() {
    this.stage = 'selectDrug';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
  },
  async mounted() {
    await this.$store.dispatch('getRefillOrder');
    await this.getRefillData();
  },
  methods: {
    setupProgress() {
      const prog = [];
      prog.push({ en: 'selectDrug', zh: '選擇補充藥物' });
      if (this.refillToNewDevice) {
        prog.push({ en: 'setMaxAmount', zh: '設定最大庫存' });
      } else {
        prog.push({ en: 'setPatch', zh: '確認批號' });
      }
      prog.push({ en: 'setExpirationDate', zh: '確認效期' });
      if (this.$store.state.user.user.task_privilege.refill_drug === false) {
        prog.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      prog.push({ en: 'action', zh: '進行補藥' });
      return prog;
    },
    setupMultiProgress() {
      return [
        'confirm',
        'finish',
      ];
    },
    setupConfirmProgress() {
      const p = [];
      // remove individual refill temporaily. please notice this might effect the old version.
      if (this.refillToNewDevice) {
        p.push('setMaxAmount');
      } else {
        p.push('setPatch');
      }
      p.push('setExpirationDate');
      p.push('autoCalcRefillPayload');
      if (this.$store.state.user.user.task_privilege.refill_drug === false) {
        p.push('rxCheck');
      }
      p.push('action');
      p.push('finish');
      return p;
    },
    getDrugStorages(drugStorageList, targetMedId) {
      return _.filter(drugStorageList, (drugStorage) => { return drugStorage.medication.id === targetMedId; });
    },
    getBarcode(val) {
      this.instance.get('/api/medication/', { params: { package_code2: val } })
      .then((res) => {
        if (res.data.total === 0) {
          this.instance.get('/api/medication/', { params: { package_code: val } })
          .then((res) => {
            if (res.data.total === 0) {
              this.$store.commit('SET_MESSAGE', {
              type: 'warn',
              context: '查無此藥物，請確認條碼為藥盒(身)條碼',
              });
            }else {
              const targetMed = res.data.results[0];
              let drugStorages = [];
              //20190408 料位號(targetMed.CGMH_number)
              console.log(targetMed.CGMH_number);
              this.$store.commit('FILTER_DRUG_IN_DEVICE', { mode: '', searchText: targetMed.CGMH_number });
              /////////////////////////////////////////////////
              // search refill planning first.
              drugStorages = this.getDrugStorages(this.$store.state.drugInDevice.RefillDrugInDeviceList, targetMed.id);
              if (drugStorages.length === 0) {
                drugStorages = this.getDrugStorages(this.$store.getters.drugInDeviceList, targetMed.id);
              }
              if (drugStorages.length === 1) {
                this.$store.commit('SELECT_DRUG_IN_DEVICES_FROM_ALL', drugStorages[0].id);
                this.$store.commit('SET_CURRENT_DEVICE_FROM_ALL', drugStorages[0].device.id);
                this.$store.dispatch('setDrug', drugStorages[0].medication.id);
                this.stage = 'setFlowData';
              } else if (drugStorages.length > 1) {
                this.drugStorageIdsForSelected = drugStorages.map(x => x.id);
                //this.showRefillSelection = true;
              } else {
                this.$store.commit('SET_MESSAGE', {
                  type: 'warn',
                  context: '藥櫃內無存放此藥物',
                });
              }
            } 
          });  
        } else {
          const targetMed = res.data.results[0];
          let drugStorages = [];
          //20190408 料位號(targetMed.CGMH_number)
          console.log(targetMed.CGMH_number);
          this.$store.commit('FILTER_DRUG_IN_DEVICE', { mode: '', searchText: targetMed.CGMH_number });
          /////////////////////////////////////////////////    
          // search refill planning first.
          drugStorages = this.getDrugStorages(this.$store.state.drugInDevice.RefillDrugInDeviceList, targetMed.id);
          if (drugStorages.length === 0) {
            drugStorages = this.getDrugStorages(this.$store.getters.drugInDeviceList, targetMed.id);
          }
          if (drugStorages.length === 1) {
            this.$store.commit('SELECT_DRUG_IN_DEVICES_FROM_ALL', drugStorages[0].id);
            this.$store.commit('SET_CURRENT_DEVICE_FROM_ALL', drugStorages[0].device.id);
            this.$store.dispatch('setDrug', drugStorages[0].medication.id);
            this.stage = 'setFlowData';
          } else if (drugStorages.length > 1) {
            this.drugStorageIdsForSelected = drugStorages.map(x => x.id);
            //this.showRefillSelection = true;
          } else {
            this.$store.commit('SET_MESSAGE', {
              type: 'warn',
              context: '藥櫃內無存放此藥物',
            });
          }
        }
      });
    },
    selectionDone() {
      this.showRefillSelection = false;
      this.stage = 'setFlowData';
    },
    cancel() {
      this.$router.push({ name: 'Main' });
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_REFILL' });
    },
    cancelSelection() {
      this.showRefillSelection = false;
    },
    async changeStage(val) {
      this.deselectAll(); // clear the buffer
      if (val === 'selectDrug') { await this.getRefillData(); }
      if (val === 'selectLowStock') { await this.$store.dispatch('getLowStockDrugInDevice'); }
      if (val === 'refill') { await this.$store.dispatch('getRefillOrder'); }
      this.stage = val;
    },
    startFlow() {
      if (Object.keys(this.$store.state.drugInDevice.selectedDrugInDevice).length === 0) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請至少選擇一項儲存藥物' });
      } else {
        this.stage = 'setFlowData';
      }
    },
    getNewDeviceForRefill(deviceId) {
      // update progress
      this.refillToNewDevice = true;
      this.progress = this.setupProgress();
      this.$store.commit('SET_PROGRESS', this.progress);
      this.confirmProgress = this.setupConfirmProgress();
      // update data and start flow.
      this.$store.commit('SET_CURRENT_DEVICE_FROM_ALL', deviceId);
      this.stage = 'setFlowData';
      this.startType = 'createNewDrugStorage';
    },
    getRefillData() {
      // filter out the drugStorage in the refill plan.
      return this.instance.get('/api/drug-storage/', {
        params: {
          device__net__system: this.$store.state.device.systemId,
          refill: true,
        },
      })
      .then((res) => {
        const filteredList = [];
        res.data.results.forEach((item) => {
          item.selected = false;
          const theExpiredDate = moment(item.expired_date);
          const todayDate = moment();
          const remainExpiredDays = theExpiredDate.diff(todayDate, 'days');
          if (remainExpiredDays >= 0) {
            filteredList.push(item);
          }
        });

        this.$store.commit('SET_DRUG_IN_DEVICE_LIST', filteredList);
      });
    },
    async getAllConfirmData(data) {
      this.stage = 'finish';
      this.$store.dispatch('resetAll');
      await Promise.all([
        this.$store.dispatch('getSystemInfo'),
        this.getRefillData(),
        this.$store.dispatch('getLowStockDrugInDevice'),
        this.$store.dispatch('getRefillOrder'),
      ]);
      this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
      this.stage = 'selectDrug';
      this.startType = 'refill';
      this.progress = this.setupProgress();
      this.multiProgress = this.setupMultiProgress();
      this.confirmProgress = this.setupConfirmProgress();
    },
    selectAll() {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
      this.$store.dispatch('selectAllDrugStorageAndDevices');
    },
    deselectAll() {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
    },
    getDrugStorageWithSameMed(drugStorageList) {
      // save the selected medication information
      this.$store.dispatch('setDrug', drugStorageList[0].medication.id);
      // let user select drugStorage with same medication
      this.$store.commit('SET_DRUG_IN_DEVICE_LIST', drugStorageList);
      this.stage = 'DrugStorageInOneMed';
    },
  },
  watch: {
    stage(val) {
      switch (val) {
        case 'selectDrug':
          this.progress[0].zh = '選擇補充藥倉';
          this.$store.commit('SHOW_LOGOUT', true);
          break;
        case 'selectLowStock':
          this.progress[0].zh = '存量過低清單';
          this.$store.commit('SHOW_LOGOUT', true);
          break;
        case 'refill':
          this.progress[0].zh = '藥倉補藥規劃';
          this.$store.commit('SHOW_LOGOUT', true);
          break;
        default:
          this.$store.commit('SHOW_LOGOUT', false);
          console.log(this.stage);
      }
    },
  },
};
</script>


<style lang="sass">


</style>



// WEBPACK FOOTER //
// RefillDrug.vue?38d21151